import { useQuery } from 'react-query';
import { fetchLungsAuscultationPhysicalExamination } from '@higo/api/lib/services';
import { useExaminationApiContext } from '@higo/common/src/features/ExaminationPage/providers';
import { ExaminationQueryKey } from '@higo/common/src/features/ExaminationPage/ExaminationQueryKey';
import { LungsAuscultationPhysicalExaminationDTO } from '@higo/api/lib/models/physicalExaminations';
import { pipe, prop } from 'rambda';
import { useExaminationAzureResourcesQuery } from '@higo/common/src/features/ExaminationPage/hooks/queries/useExaminationAzureResourcesQuery';
import {
  indexByFileName,
  remapToFileIdArray,
} from '@higo/common/src/utils/fileResourceUtils';

export const useLungsAuscultationPhysicalExaminationQuery = <
  TData = LungsAuscultationPhysicalExaminationDTO,
>(
  examinationId: number,
  select?: (dto: LungsAuscultationPhysicalExaminationDTO) => TData,
) => {
  const axios = useExaminationApiContext();

  return useQuery(
    [ExaminationQueryKey.LungsAuscultationPhysicalExamination, examinationId],
    async () => fetchLungsAuscultationPhysicalExamination(axios)(examinationId),
    {
      enabled: !isNaN(examinationId),
      select,
    },
  );
};

const selectFileResultIds: (
  data: LungsAuscultationPhysicalExaminationDTO,
) => number[] = pipe(prop('lungsResults'), remapToFileIdArray);

export const useLungsAuscultationPhysicalExaminationResourceFiles = (
  id: number,
) => {
  const { data: ids } = useLungsAuscultationPhysicalExaminationQuery(
    id,
    selectFileResultIds,
  );

  return useExaminationAzureResourcesQuery(ids ?? [], indexByFileName);
};
